import { Directive, ViewContainerRef } from '@angular/core';

@Directive({
    selector: '[notification-item]',
    standalone: false,
})
export class NotificationDirective {
    constructor(public viewContainerRef: ViewContainerRef) {}
}
